import { getJson, postJson } from '../lib/apiClient';
import type { StoredUser } from '../lib/auth';

interface LoginResponse {
  jwt?: string;
  user?: StoredUser;
  error?: string;
}

export const authApi = {
  login: (email: string, password: string) =>
    postJson<LoginResponse>(
      '/login-user.php',
      {
        email,
        password,
      },
      false
    ),
  checkStatus: () => getJson<'success' | string>('/check-status.php'),
};
